export const SocialData = [
  {
    platform: "GitHub",
    link: "https://github.com/OzerOzturk",
    icon: require("../../assets/icons/github.png").default,
  },
  {
    platform: "LinkedIn",
    link: "https://www.linkedin.com/in/ozerozturk/",
    icon: require("../../assets/icons/linkedin.png").default,
  },
  {
    platform: "Medium",
    link: "https://ozerozturkk.medium.com/",
    icon: require("../../assets/icons/medium.png").default,
  },
  {
    platform: "Twitter",
    link: "https://twitter.com/ozerozturkkk",
    icon: require("../../assets/icons/twitter.png").default,
  },
  {
    platform: "Unsplash",
    link: "https://unsplash.com/@ozerozturk",
    icon: require("../../assets/icons/unsplash.png").default,
  },
  {
    platform: "Wordpress",
    link: "https://ozerozturkk.wordpress.com/",
    icon: require("../../assets/icons/wordpress.png").default,
  },
];
